import { endOfDay, startOfDay, subDays, subHours } from 'date-fns'

export const getRangeValues = (range: string | null, now: undefined | Date = new Date()) => {
  switch (range) {
    case '24h': {
      return { from: subHours(now, 24), to: now }
    }
    case '7d': {
      return { from: startOfDay(subDays(now, 6)), to: endOfDay(now) }
    }
    case '30d': {
      return { from: startOfDay(subDays(now, 29)), to: endOfDay(now) }
    }
    default: {
      return
    }
  }
}
